import { Button, Flex } from '@agrotoken-tech/ui';
import { useTranslation } from '@bcba/react-hooks';
import { VALIDATION_STATUSES, ValidationStatus } from '@bcba/types';
import React, { useEffect, useState } from 'react';

interface ActionButtonsProps {
  status?: ValidationStatus;
  isLoadingSave: boolean;
  formHasChanges: boolean;
  handleSave?: () => void;
  thisSectionNeedsApproval?: boolean;
}

export const useDigitalDossierActionButtons = ({
  status = VALIDATION_STATUSES.INCOMPLETE,
  isLoadingSave,
  handleSave,
  formHasChanges = false,
  thisSectionNeedsApproval = true,
}: ActionButtonsProps) => {
  const { t } = useTranslation();
  const isApproved = status === VALIDATION_STATUSES.APPROVED;
  const [isFormReadOnly, setIsFormReadOnly] = useState(isApproved);

  let actionButtons = (
    <Flex justifyContent={'end'} gap={3}>
      {isApproved && isFormReadOnly ? (
        <Button variant={'primary'} onClick={() => setIsFormReadOnly(false)}>
          {t('common.updateData')}
        </Button>
      ) : (
        <Button
          variant={'primary'}
          onClick={handleSave}
          isLoading={isLoadingSave}
          isDisabled={!formHasChanges}
          type="submit"
        >
          {t('common.requestApproval')}
        </Button>
      )}
    </Flex>
  );

  if (!thisSectionNeedsApproval) {
    actionButtons = (
      <Flex justifyContent={'end'} gap={3} mt={6}>
        <Button
          variant={'primary'}
          onClick={handleSave}
          isLoading={isLoadingSave}
          isDisabled={!formHasChanges}
          type="submit"
        >
          {t('common.saveChanges')}
        </Button>
      </Flex>
    );
  }

  useEffect(() => {
    if (isApproved) {
      setIsFormReadOnly(true);
    }
  }, [isApproved]);

  return { actionButtons, isFormReadOnly };
};

export default useDigitalDossierActionButtons;
